import React, {Component} from "react";
import {withRouter} from 'react-router-dom';
import {Icon, Popover} from "antd";
import NotificationBanner from ".././Notification/style";

class Notification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            notifications: []
        };
        window.notify = this.show.bind(this);
        window.resetNotify = this.reset.bind(this);
        window.clearLastNotify = this.clearLast.bind(this);
    }

    /**
     * this function will clear notification from app
     * @memberof Notification
     */


  reset = () => {
        this.setState({
            notifications: []
        });
    };

    clearNotify = (index, timeout) => {
        if (timeout) {
            setTimeout(
                () =>
                    this.setState(prevState => ({
                        notifications: prevState.notifications.filter((notification,i)=>i!== index)
                    })),
                timeout
            );
        } else {
            this.setState(prevState => ({
                notifications: prevState.notifications.filter((notification,i)=>i!== index)
            }));
        }
    };

    clearLast = () => {
        let {notifications = []} = this.state;
        notifications.pop();
        this.setState({
            notifications
        });
    };

    /**
     * This will push the given notification into stock.
     * It requires object of notification
     *  @notification {
     *      clearFirst?: bool,
     *      message: string | JSX | HTMLElement
     *      icon?: string
     *      closable?: bool
     *      type: 'error' | "warning" | "info" | "success"
     *      auto?: bool
     *      timeout?: Integer
     *  }
     * @memberof Notification
     */
    show = ({
                clearFirst = true,
                message = "Oops, Something went wrong! Please try again later",
                icon = null,
                closable = true,
                type = "info",
                auto = true,
                extra = "",
                link="",
                title,
                timeout = 5000,
            }) => {
        let {notifications = []} = this.state;
        let newIndex = notifications.length;
        timeout = timeout || 5000;
        window.scrollTo(0,0);
        if(!this.props.notShow){
        this.setState(
            {
                notifications: notifications.concat({
                    message,
                    extra,
                    icon,
                    title,
                    type,
                    closable,
                    link,
                    index: newIndex
                })
            },
            () => {
                auto && this.clearNotify(newIndex, timeout)
            }
        );
        }
    };

    componentDidUpdate(prevProps, prevState) {
      if(this.props.location.pathname !== prevProps.location.pathname){
        this.setState({
          notifications: []
        })
      }
      if(prevState.notifications !== this.state.notifications && this.state.notifications &&  document.getElementById('topbar-container')){
        document.getElementById('topbar-container').scrollIntoView();
      }
    }

  render() {
        const {notifications = []} = this.state;
        return (
            <React.Fragment>
                {notifications &&
                notifications.map((n, i) => {
                    const {visible, message, title, icon, type, closable,extra,link} = n;
                    return (
                        <NotificationBanner key={i} type={type} className="banner-container">
                            <div
                                className={`banner ${icon ? "has-icon" : ""} ${closable ? "has-dismiss" : ""} ${
                                    type ? `banner-${type}` : ""
                                    }`}
                            >
                                {title && <strong>{title}</strong>}
                                {title && <br/>}
                                {icon && <Icon type={icon} theme="filled" className="icon"/>}
                                <span className="content">{message}</span>
                                {extra ?
                                    <span className="content">{' '}<Popover
                                        content={extra}><a>here</a></Popover></span>
                                    : ''
                                }
                                {link ?
                                    <span className="content">{' '}{link}</span> :''
                                }
                                {closable && (
                                    <Icon type="close" className="dismiss" onClick={() => this.clearNotify(i)}/>
                                )}
                            </div>
                        </NotificationBanner>
                    );
                })}
                {this.props.children}
            </React.Fragment>
        );
    }
}

export default withRouter(React.memo(Notification));
